import styled from 'styled-components';

const SearchContainer = styled.div`
  padding-top: 114px;
  padding-bottom: 158px;
  width: 100%;
`;

export default SearchContainer;
